import React from 'react';
import { Button, HeadingText, StackLayout } from '@leagueplatform/genesis-core';

export type InfinitePaginationProps = {
  currentPageLabel: string;
  nextPageLabel?: string;
  previousPageLabel?: string;
  previousPageCursor?: string;
  nextPageCursor?: string;
  onNextPage?: (event: React.SyntheticEvent) => void;
  onPreviousPage?: (event: React.SyntheticEvent) => void;
  isLoading?: boolean;
};

export function InfinitePagination({
  currentPageLabel,
  nextPageLabel,
  previousPageLabel,
  previousPageCursor,
  nextPageCursor,
  onNextPage,
  onPreviousPage,
  isLoading = false,
}: InfinitePaginationProps) {
  const [isPreviousPageLoading, setIsPrevousPageLoading] =
    React.useState(false);
  const [isNextPageLoading, setIsNextPageLoading] = React.useState(false);

  // Reset the loading states once the reloading is complete.
  React.useEffect(() => {
    if (!isLoading) {
      setIsNextPageLoading(false);
      setIsPrevousPageLoading(false);
    }
  }, [isLoading]);

  return (
    <StackLayout
      orientation="horizontal"
      verticalAlignment="center"
      horizontalAlignment="spaceBetween"
    >
      <Button
        icon="interfaceChevronLeft"
        priority="secondary"
        quiet
        hideLabel
        disabled={!previousPageCursor}
        onClick={(event: React.SyntheticEvent) => {
          setIsPrevousPageLoading(true);
          onPreviousPage?.(event);
        }}
        loading={isPreviousPageLoading}
      >
        {previousPageLabel}
      </Button>
      <HeadingText
        level="2"
        size={{
          '@initial': 'xxl',
          '@mobile': 'sm',
        }}
      >
        {currentPageLabel}
      </HeadingText>
      <Button
        icon="interfaceChevronRight"
        priority="secondary"
        quiet
        hideLabel
        disabled={!nextPageCursor}
        onClick={(event: React.SyntheticEvent) => {
          setIsNextPageLoading(true);
          onNextPage?.(event);
        }}
        loading={isNextPageLoading}
      >
        {nextPageLabel}
      </Button>
    </StackLayout>
  );
}
